<template>
  <svg
    width="50px"
    height="50px"
    viewBox="0 0 50 50"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <!-- Generator: Sketch 63.1 (92452) - https://sketch.com -->
    <title>注意</title>
    <desc>Created with Sketch.</desc>
    <g id="配件" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g
        id="3-3-多VIN无法确认配件"
        transform="translate(-701.000000, -271.000000)"
        fill-rule="nonzero"
      >
        <g id="注意" transform="translate(701.000000, 271.000000)">
          <path
            d="M25.0000291,50.000062 L25.000028,50.000062 C11.192883,50.000062 -1.09278447e-06,38.8071741 -1.09278447e-06,25.0000291 C-1.09278447e-06,25.0000291 -1.09278447e-06,25.0000291 -1.09278447e-06,25.0000291 L-1.09278447e-06,25.0000329 C-1.09278447e-06,11.1928879 11.192883,3.77489694e-06 25.000028,3.77489694e-06 L25.0000269,3.77489694e-06 C38.8071719,3.77489694e-06 50.000056,11.1928879 50.000056,25.0000329 L50.000056,25.0000329 C50.000056,38.8071778 38.8071719,50.000062 25.0000269,50.000062 L25.0000291,50.000062 Z"
            id="路径"
            fill="#FAAD14"
          ></path>
          <path
            d="M23.6972444,29.4556007 C23.9972447,30.3556017 24.5972454,30.9556024 25.4944681,30.9556024 C26.3916909,30.9556024 26.9916916,30.3528234 27.2889136,29.4556007 L28.4861368,12.9944487 L28.4861368,12.9945118 C28.4831196,11.3430743 27.1459643,10.0046206 25.4945317,10.0000015 C23.6944662,10.0000015 22.5000214,11.4972249 22.5000214,13.2916703 L23.6972445,29.4583395 L23.6972444,29.4556007 Z M25.4944681,33.9444926 C23.6972444,33.9444926 22.5000213,35.144494 22.5000213,36.9389395 C22.5000213,38.7361632 23.6972444,39.9333863 25.4944681,39.9333863 C27.2889136,39.9333863 28.4861367,38.7361632 28.4861367,36.9389395 C28.4861367,35.144494 27.2916919,33.9444926 25.4944681,33.9444926 Z"
            id="形状"
            fill="#FFFFFF"
          ></path>
        </g>
      </g>
    </g>
  </svg>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Warn'
});
</script>
